import SecondaryButton from "../../../../components/Buttons/SecondaryButton";
import Input from "../../../../components/Input/Input";
import classes from "./PodcastCTA.module.css";

function PodcastCTA({ formatKey, handleSubmit }) {
  return (
    <section className={classes.main} id="book-a-podcast">
      <div className={classes.container}>
        <div className={classes.leftSection}>
          <div className={classes.content}>
            <h2 className={classes.heading}>
              FINAL THOUGHT
              <br />
              WHY THIS MATTERS?
            </h2>

            <p className={classes.description}>
              The best leaders don't just lead—they share. Your challenges,
              successes, and vision for education could inspire thousands.
            </p>

            <div className={classes.ctaText}>
              So, are you ready to{" "}
              <span className={classes.highlight}>STEP UP</span> and
              <br />
              make an <span className={classes.highlight}>IMPACT</span>?
            </div>
          </div>
        </div>

        <div className={classes.rightSection}>
          <div className={classes.subscribeCard}>
            <h3 className={classes.subscribeHeading}>
              Subscribe to
              <br />
              The Bright
              <br />
              Side of Life
            </h3>

            <form className={classes.form} onSubmit={handleSubmit}>
              {["name", "city", "phoneNo", "email", "schoolName"].map(
                (placeholder) => (
                  <Input
                    key={placeholder}
                    type="text"
                    name={placeholder.toLowerCase()}
                    placeholder={`Enter ${formatKey(placeholder)}`}
                    required
                  />
                )
              )}
              <SecondaryButton className={classes.btn} type="submit">
                Register Now
              </SecondaryButton>
            </form>
            <p className={classes.privacyText}>
              We respect your privacy. Unsubscribe at any time.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default PodcastCTA;
